import api from './utilBackoffice';

const controller = 'SaldoContrato';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  ExportExcelRequest: dto => {
    return api.Axios.Post(url + '/ExportExcelRequest', dto);
  },
  DownloadExcel: (dto, fileName) => {
    return api.Axios.DownloadExcelFile(url + '/DownloadExcel', dto, fileName);
  },
  FechamentoMensal: dto => {
    return api.Axios.Post(url + '/FechamentoMensal', dto);
  }
});
